module.exports = __webpack_public_path__ + "media/images/other/cursor-e1df595ddd042ccd69a926375216194f.png";